import { flow } from 'fp-ts/function';
import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch, PaymentCard, Preauthorization } from '@mews-commander/types';
import { withScopeContext } from '@mews/framework';
import { getPreauthorization } from '@mews-commander/legacy-entities/src/ducks';
import { handlePreauthorizationClick } from '../../../../actions/payments';
import { getPaymentCard, getPaymentCardByPreauthorization } from '../../../../selectors';

interface StateProps {
    paymentCard: PaymentCard;
    preauthorization?: Preauthorization;
}

interface DispatchProps {
    handlePreauthorizationClick: (preauthorizationId: string) => void;
}

interface OwnProps {
    accountId: string;
    billId: string;
    preauthorizationId: string;
    scope: string;
    invalidateQuery: () => void;
}

export const connectPreauthorizationOption = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        preauthorization: (state: ApplicationState, { accountId, preauthorizationId }: OwnProps) =>
            getPreauthorization(state, { ownerId: accountId, id: preauthorizationId }),
        paymentCard: (state: ApplicationState, { accountId, preauthorizationId }: OwnProps) => {
            const { id: paymentCardId } = getPaymentCardByPreauthorization(state, {
                ownerId: accountId,
                id: preauthorizationId,
            });
            return getPaymentCard(state, { id: paymentCardId });
        },
    }),
    (dispatch: CommanderThunkDispatch, { billId, scope, invalidateQuery }) => ({
        handlePreauthorizationClick: async (preauthorizationId: string) => {
            await dispatch(handlePreauthorizationClick({ preauthorizationId, billId, scope }));
            invalidateQuery();
        },
    })
);

export const connectScopedPreauthorizationOption = flow<
    $TSFixMe,
    ComponentType<OwnProps>,
    ComponentType<Omit<OwnProps, 'scope'>>
>(connectPreauthorizationOption, withScopeContext);
